// extracted by mini-css-extract-plugin
export default {"label":"ErrorMessageLabel-module__label--ljH+c"};